module.exports = __webpack_public_path__ + "static/media/naga-logo-big.a27b8faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/naga-logo-big.png
// module id = 794
// module chunks = 0